import { ChangeEvent } from 'react'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Clear, Search } from '@mui/icons-material'
import { InputAdornment, TextField } from '@mui/material'
import { t } from '@lingui/core/macro'

const SearchContainer = styled.div`
  padding: 8px 12px;
`

const icon = css`
  opacity: 0.5;
`

const clearIcon = css`
  cursor: pointer;
`

interface Props {
  searchTerm: string
  handleSearch: (e: ChangeEvent<HTMLInputElement>) => void
  handleClearSearch: () => void
}

export const SearchColumns = ({ searchTerm, handleSearch, handleClearSearch }: Props) => {
  return (
    <SearchContainer>
      <TextField
        fullWidth
        margin="dense"
        id="search"
        placeholder={t`Search`}
        variant="outlined"
        value={searchTerm}
        onChange={handleSearch}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search css={icon} />
            </InputAdornment>
          ),
          endAdornment: Boolean(searchTerm) && (
            <InputAdornment position="end">
              <Clear css={[icon, clearIcon]} onClick={handleClearSearch} />
            </InputAdornment>
          ),
        }}
      />
    </SearchContainer>
  )
}
